import useEventBus from '@/natives/libs/hooks/useEventBus';
import i18n from '@/natives/libs/i18n';

let countryOrRegionIndex = Number(localStorage.getItem('hik_connect_pro_country'));
let initContentObj = [];
const countryOrRegionChange = useEventBus('country-or-region-change');
let timer;
let curImg = 0;

function getList(reset) {
  if (countryOrRegionIndex === 22 || countryOrRegionIndex === 109) {
    initContentObj = [
      {
        text1: 'detail_login_banner_3',
        text2: 'label_login_banner_3',
        img: 'reduced_installation_time_banner.png.webp',
        name: '节约配置时间'
      },
      {
        text1: 'detail_login_banner_4',
        text2: 'label_login_banner_4',
        img: 'remote_device_maintenavnce_banner.png.webp',
        name: '远程设备运维'
      }
    ];
  } else {
    initContentObj = [
      {
        text1: 'hik_pro_connect',
        text2: 'what_is_hpc_answer_new',
        img: 'hpc_produce_banner.png.webp',
        name: 'HPC介绍'
      },
      {
        text1: 'detail_login_banner_3',
        text2: 'label_login_banner_3',
        img: 'reduced_installation_time_banner.png.webp',
        name: '节约配置时间'
      },
      {
        text1: 'detail_login_banner_4',
        text2: 'label_login_banner_4',
        img: 'remote_device_maintenavnce_banner.png.webp',
        name: '远程设备运维'
      }
    ];
  }

  selfWrap(initContentObj, reset);
}

function selfWrap(initContentObj, reset) {
  var content = document.getElementById('login-banner-wrapper-content');
  let str = '';
  initContentObj.forEach((item, index) => {
    str += `
    <div class="banner-item${index === 0 ? ' active' : ''}" style="background-image: url('/assets/img/epartner_banner/${
      item.img
    }');">
        <div class="banner-item-title" title="${i18n.t(item.text1)}">${i18n.t(item.text1)}</div>
        <div class="banner-item-tips" title="${i18n.t(item.text2)}">${i18n.t(item.text2)}</div>
    </div>
    `;
  });
  content.innerHTML = str;
  const hb = 2500; //循环时间
  let wrapper = document.getElementById('login-banner-wrapper');
  let width = content.offsetWidth;
  let list = document.querySelectorAll('.banner-content .banner-item');
  let dots = document.querySelector('.dots');
  if (reset) {
    // 切换国家重置参数
    dots.innerHTML = '';
    clearInterval(timer);
    curImg = 0;
  }
  let dotss = dots.children;
  const len = list.length;

  // 创建一个文档片段，此时还没有插入到 DOM 结构中
  const frag = document.createDocumentFragment();
  // 根据图片数量添加相应的小圆点到文档片段中
  for (let i = 0; i < len; i++) {
    const dot = document.createElement('span');
    dot.className = 'quiet';
    dot.setAttribute('data-key', i);
    // 先插入文档片段中
    frag.appendChild(dot);
  }
  // 将小圆点片段统一插入到 DOM 结构中
  dots.appendChild(frag);

  // 第一个小圆点高亮显示
  dots.children[0].className = 'active';

  //初始化位置
  list.forEach((item, index) => {
    let tranWidth = width * index;
    if (index === len - 1) {
      tranWidth = -width;
    }
    item.style.transform = `translateX(${tranWidth}px)`;
  });

  function autoRun() {
    curImg++;
    if (curImg >= len) {
      curImg = 0;
    }
    roll(curImg);
  }

  // 循环添加小圆点的触发事件
  dots.onmouseover = function (e) {
    const dom = e.target;
    const key = dom.getAttribute('data-key');
    if (key) {
      roll(+key);
    }
  };

  // 设置位置并进行滚动
  function roll(key) {
    //重置active
    resetClass();
    list[key].className = 'banner-item active';
    dotss[key].className = 'active';
    list.forEach((item, index) => {
      let tranWidth = width * 2;
      if (index === key) {
        tranWidth = 0;
      }
      if (index === key - 1) {
        tranWidth = -width;
      }
      if (index === key + 1) {
        tranWidth = width;
      }
      if (key + 1 >= len && index === 0) {
        tranWidth = width;
      }
      if (key - 1 < 0 && index === len - 1) {
        tranWidth = -width;
      }
      item.style.transform = `translateX(${tranWidth}px)`;
    });
  }

  function resetClass() {
    // 循环修改所有圆点默认样式
    for (var i = 0; i < len; i++) {
      list[i].className = 'banner-item quiet';
      dotss[i].className = 'quiet';
    }
  }
  timer = setInterval(autoRun, hb);

  // 添加事件：鼠标移动到wrapper上，左右切换按钮显示
  wrapper.onmouseover = function () {
    clearInterval(timer);
  };
  // 添加事件：鼠标移出wrapper，左右切换按钮隐藏
  wrapper.onmouseout = function () {
    timer = setInterval(autoRun, hb);
  };
}

function init() {
  countryOrRegionChange.on((index) => {
    if (index !== countryOrRegionIndex) {
      countryOrRegionIndex = index;
      getList(true);
    }
  });
  getList();
}

/**
 * mounted
 */
(function () {
  init();
})();
